import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-quantitativo`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getLoadFields(queryParms) {
            return repository.get(`${baseUrl}/fields?${urlUtil.serialize(queryParms)}`)
        },
    }
}